<template>
  <vue-modal
    name="patternMaker"
    :pivotY="0.15"
    width="75%"
    height="auto"
    :scrollable="true"
    :click-to-close="false"
    :classes="[
      'generic-modals',
      'v--modal',
      'patternmaker'
    ]"
  >
    <section class="patternmaker-wrapper content modal-scroll-area">
      <div>
        <div class="patternmaker-top-nav">
          <div class="patternmaker-top-nav-logo">
            <img :src="`${assetsPath}/images/common/customs_logo_red.png`" alt/>
          </div>
          <div>
            <h3 class="patternmaker-top-nav-title">{{ translations.customPatternMakerTitle }}</h3>
          </div>
        </div>
        <patternmaker-view @disableStatus="setDisableStatus"></patternmaker-view>
        <div slot="top-right">
          <button
            @click="closeModal"
            :disabled="disableStatus"
            class="patternmaker-top-nav-close"
            title="Close"
            type="button"
          >
            <span class="icon-close"></span>
          </button>
        </div>
      </div>
    </section>
   </vue-modal>
</template>

<script>
import patternmakerView from '@/components/PatternMaker/MainViews/PatternMaker';
import patternMaker from '@/mixins/PatternMaker';

export default {
  name: "patternmakerModal",
  components: {
    patternmakerView
  },
  mixins: [patternMaker]
}
</script>

<style lang="scss">
  .customs-tools {
    @import "~@/styles/_components/PatternMaker/PatternMaker.scss";
  }
</style>
